import { ComponentType } from '../types/app-types';
import Modal from './modal';
import Popup from './popup';
import Price from './price';
import Header from './header';
import Payment from './payment';
import Backdrop from './backdrop';
import Calendar from './calendar';
import Timeline from './timeline';
import CartItem from './cart-item';
import CartCount from './cart-count';
import PromoCode from './promo-code';
import TextFitter from './text-fitter';
import CartSummary from './cart-summary';
import PickupSelector from './pickup-selector';
import StatefulButton from './stateful-button';
import StoreLocator from './store-locator';
import QuantitySelector from './quantity-selector';
import ProductCustomizer from './product-customizer';
import VideoController from './video-controller';

export const components: Record<ComponentType, any> = {
  modal: Modal,
  popup: Popup,
  price: Price,
  header: Header,
  payment: Payment,
  backdrop: Backdrop,
  calendar: Calendar,
  timeline: Timeline,
  'cart-item': CartItem,
  'cart-count': CartCount,
  'promo-code': PromoCode,
  'text-fitter': TextFitter,
  'cart-summary': CartSummary,
  'pickup-selector': PickupSelector,
  'stateful-button': StatefulButton,
  'store-locator': StoreLocator,
  'quantity-selector': QuantitySelector,
  'product-customizer': ProductCustomizer,
  'video-controller': VideoController,
};

export default components;
